var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Performance'),_c('ReductionMonitoring'),_c('OverallReductionTargets')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }